module.exports = __webpack_public_path__ + "img/4.2bd6bd3d.png";